import { Modal, Button, Typography } from 'antd';
import '@src/styles/components/customModal.scss';
import PropTypes from 'prop-types';
import { useText } from './Text';

const { Text } = Typography;

const CustomAddCarOrderSummaryFleetLimit = ({ title, isModalVisible, handleCancel, clickOk }) => {
  const youAreGrowingYourFleetItMightBe = useText('youAreGrowingYourFleetItMightBe');
  const wouldYouLikeToIncreaseYourFleetLimit2 = useText('wouldYouLikeToIncreaseYourFleetLimit2');
  const increaseFleetLimit = useText('increaseFleetLimit');
  const notInterested = useText('notInterested');
  return (
    <Modal
      visible={isModalVisible}
      onCancel={handleCancel}
      style={{
        borderRadius: '8px', // Modal köşelerini yuvarlama
        padding: '12px 14px 40px 39px',
      }}
      className="add-new-car-order-summary-modal"
      footer={null}
      centered
      maskClosable={false} // Dışarı tıklanınca kapanmayı engelle
      keyboard={false}
    >
      <div
        style={{
          display: 'flex',
          marginTop: 20,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <Text className="filo-limit-add-modal-title">{title}</Text>
        <Text className="cost-center-modal-text">
          {youAreGrowingYourFleetItMightBe}
        </Text>

        <strong style={{ marginTop: 10 }}>{wouldYouLikeToIncreaseYourFleetLimit2}</strong>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            marginTop: 20,
          }}
        >
          <Button
            key="ok"
            type="primary"
            style={{
              color: '#efefef',
              borderRadius: 6,
              width: 160,
              height: 38,
              fontWeight: 'bold',
            }}
            onClick={clickOk}
          >
            {increaseFleetLimit}
          </Button>
          <Button
            key="ok"
            style={{
              color: '#000',
              borderRadius: 6,
              width: 160,
              height: 38,
              fontWeight: 'bold',
              backgroundColor: 'transparent',

              borderWidth: 0,
              marginTop: 10,
              boxShadow: 'none',
            }}
            onClick={handleCancel}
          >
            <Text style={{ textDecoration: 'underline' }}>{notInterested}</Text>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

CustomAddCarOrderSummaryFleetLimit.propTypes = {
  title: PropTypes.string,
  isModalVisible: PropTypes.bool,
  handleCancel: PropTypes.func,
  clickOk: PropTypes.func,
};

export default CustomAddCarOrderSummaryFleetLimit;
